import React from "react";
import { Chip } from "@mui/material";
import FilterIcon from "@mui/icons-material/FilterAlt";

// A quick-filter toggle: a clickable chip with a filter icon, filled when active, outlined when not.
// `toggle` is called with the current active state — flip it in the handler.
function QuickFilter({
  active,
  label,
  toggle,
}: {
  active: boolean;
  label: string;
  toggle: (active: boolean) => void;
}) {
  return (
    <Chip
      label={label}
      icon={<FilterIcon fontSize="small" />}
      variant={active ? "filled" : "outlined"}
      clickable
      onClick={() => toggle(active)}
      onDelete={active ? () => toggle(active) : undefined}
    />
  );
}

export default QuickFilter;
